import {
  BookUser,
  Building,
  // Container,
  FileClock,
  Home,
  MonitorCog,
  Shield,
  Siren,
  Users,
  // Wallet,
} from "lucide-react"

import { SidebarNavItem } from "@/types/nav"

export const navigation: SidebarNavItem[] = [
  {
    title: "Dashboard",
    href: "/app",
    code: "dashboard",
    modules: ["dashboard"],
    icon: Home,
    section: "main",
    path: ["/app", "/app/export"],
    items: [
      {
        title: "Dashboard",
        href: "/app",
        path: ["/app"],
        section: "dashboard",
        modules: ["dashboard"],
        items: [],
      },
      {
        title: "Export",
        href: "/app/export",
        section: "dashboard",
        modules: ["export_data"],
        path: ["/app/export"],
        items: [],
      }
    ],
  },
  {
    title: "Patrol",
    href: "/app/patrol",
    code: "patrol",
    icon: Shield,
    modules: ["patrol", "area_assets"],
    section: "main",
    path: [
      "/app/patrol",
      "/app/patrol/detail-patrol-activity",
      "/app/patrol/export",
      "/app/patrol/area-and-assets",
      "/app/patrol/area-and-assets/edit-detail-asset",
    ],
    items: [
      {
        title: "Patrol",
        href: "/app/patrol",
        code: "patrol",
        section: "patrol",
        modules: ["patrol"],
        path: ["/app/patrol", "/app/patrol/detail-patrol-activity"],
        items: [],
      },
      {
        title: "Export",
        code: "export",
        href: "/app/patrol/export",
        section: "patrol",
        modules: ["patrol"],
        path: ["/app/patrol/export"],
        items: [],
      },
      {
        title: "Area & Assets",
        href: "/app/patrol/area-and-assets",
        code: "assets",
        section: "data",
        modules: ["area_assets"],
        path: [
          "/app/patrol/area-and-assets",
          "/app/patrol/area-and-assets/edit-detail-asset",
        ],
        items: [],
      },
    ],
  },
  {
    title: "Request",
    href: "/app/request",
    code: "request",
    modules: ["request"],
    icon: FileClock,
    section: "main",
    path: [
      "/app/request",
      "/app/request/edit-list-approval",
      "/app/request/detail-request",
    ],
    items: [
      {
        title: "Request",
        href: "/app/request",
        path: [
          "/app/request",
          "/app/request/edit-list-approval",
          "/app/request/detail-request",
        ],
        items: [],
      },
    ],
  },
  {
    title: "Panic Button",
    href: "/app/panic-button",
    code: "panicButton",
    modules: ["panic_button"],
    icon: Siren,
    section: "main",
    path: [
      "/app/panic-button",
      "/app/panic-button/add",
      "/app/panic-button/detail-panic-button",
    ],
    items: [
      {
        title: "Panic Button",
        href: "/app/panic-button",
        path: [
          "/app/panic-button",
          "/app/panic-button/add",
          "/app/panic-button/detail-panic-button",
        ],
        items: [],
      },
    ],
  },
  {
    title: "Building",
    href: "/app/building",
    code: "building",
    modules: ["building", "company"],
    icon: Building,
    section: "main",
    path: [
      "/app/building",
      "/app/building/company",
      "/app/building/detail-building",
      "/app/building/detail-building/detail-bq",
      "/app/building/detail-building/detail-bq/edit-bq",
      "/app/building/detail-building/add-building-position",
      "/app/building/detail-building/update-building-position",
      "/app/building/detail-building/add-bq",
    ],
    items: [
      {
        title: "Building",
        href: "/app/building",
        section: "building",
        modules: ["building"],
        path: [
          "/app/building",
          "/app/building/detail-building",
          "/app/building/detail-building/detail-bq",
          "/app/building/detail-building/detail-bq/edit-bq",
          "/app/building/detail-building/add-building-position",
          "/app/building/detail-building/update-building-position",
          "/app/building/detail-building/add-bq",
        ],
        items: [],
      },
      {
        title: "Company",
        href: "/app/building/company",
        section: "building",
        modules: ["company"],
        path: ["/app/building/company"],
        items: [],
      },
    ],
  },
  {
    title: "Human Resource",
    href: "/app/applicant",
    code: "humanresource",
    modules: ["hr_applicant", "schedule", "payroll"],
    icon: BookUser,
    section: "main",
    path: [
      "/app/applicant",
      "/app/applicant/add",
      "/app/applicant/detail-applicant",
      "/app/applicant/detail-applicant/add-education-and-experience",
      "/app/applicant/detail-applicant/add-certificate",
      "/app/applicant/detail-applicant/add-bank",
      "/app/applicant/detail-applicant/add-family",
      "/app/applicant/detail-applicant/add-bpjs",
      "/app/applicant/detail-applicant/add-ijazah",
      "/app/applicant/detail-applicant/add-company-building",
      "/app/applicant/detail-applicant/assign-account",
      "/app/applicant/detail-applicant/update-personel",
      "/app/applicant/detail-applicant/update-education",
      "/app/applicant/detail-applicant/update-experience",
      "/app/applicant/detail-applicant/update-certificate",
      "/app/applicant/detail-applicant/update-bank",
      "/app/applicant/detail-applicant/update-family",
      "/app/applicant/detail-applicant/update-bpjs",
      "/app/applicant/detail-applicant/update-ijazah",
      "/app/applicant/detail-applicant/update-company-building",
      "/app/applicant/detail-applicant/update-assign-account",
      // Schedule
      "/app/schedule",
      "/app/schedule/add-group-schedule",
      "/app/schedule/update-group-schedule",
      "/app/schedule/add-shift-schedule",
      "/app/schedule/edit-shift-schedule",
      "/app/schedule/add",
      "/app/schedule/edit",
      "/app/schedule/detail-attendance",
      //Payroll
      "/app/payroll",
      "/app/payroll/deduction",
      "/app/payroll/create-deduction",
      "/app/payroll/create-im",
      "/app/payroll/detail-im",
      "/app/payroll/edit-im",
      "/app/payroll/detail-payroll",
    ],
    items: [
      {
        title: "Applicant",
        href: "/app/applicant",
        code: "applicant",
        section: "Human Resource",
        modules: ["hr_applicant"],
        path: [
          "/app/applicant",
          "/app/applicant/add",
          "/app/applicant/detail-applicant",
          "/app/applicant/detail-applicant/add-education-and-experience",
          "/app/applicant/detail-applicant/add-certificate",
          "/app/applicant/detail-applicant/add-bank",
          "/app/applicant/detail-applicant/add-family",
          "/app/applicant/detail-applicant/add-bpjs",
          "/app/applicant/detail-applicant/add-ijazah",
          "/app/applicant/detail-applicant/add-company-building",
          "/app/applicant/detail-applicant/assign-account",
          "/app/applicant/detail-applicant/update-personel",
          "/app/applicant/detail-applicant/update-education",
          "/app/applicant/detail-applicant/update-experience",
          "/app/applicant/detail-applicant/update-certificate",
          "/app/applicant/detail-applicant/update-bank",
          "/app/applicant/detail-applicant/update-family",
          "/app/applicant/detail-applicant/update-bpjs",
          "/app/applicant/detail-applicant/update-ijazah",
          "/app/applicant/detail-applicant/update-company-building",
          "/app/applicant/detail-applicant/update-assign-account",
        ],
        items: [],
      },
      {
        title: "Schedule",
        href: "/app/schedule",
        code: "schedule",
        section: "Human Resource",
        modules: ["schedule"],
        path: [
          "/app/schedule",
          "/app/schedule/add-group-schedule",
          "/app/schedule/update-group-schedule",
          "/app/schedule/add-shift-schedule",
          "/app/schedule/edit-shift-schedule",
          "/app/schedule/add",
          "/app/schedule/detail-attendance",
          "/app/schedule/edit",
        ],
        items: [],
      },
      {
        title: "Payroll",
        href: "/app/payroll",
        code: "payroll",
        section: "Human Resource",
        modules: ["payroll"],
        path: [
          "/app/payroll",
          "/app/payroll/deduction",
          "/app/payroll/create-deduction",
          "/app/payroll/create-im",
          "/app/payroll/detail-im",
          "/app/payroll/edit-im",
          "/app/payroll/detail-payroll",
        ],
        items: [],
      },
    ],
  },
  // {
  //   title: "Logistic",
  //   href: "/app/logistic",
  //   code: "logistic",
  //   icon: Container,
  //   section: "main",
  //   path: ["/app/logistic"],
  //   items: [
  //     {
  //       title: "Logistic",
  //       href: "/app/logistic",
  //       path: ["/app/logistic"],
  //       items: [],
  //     },
  //   ],
  // },
  // {
  //   title: "Finance",
  //   href: "/app/finance",
  //   code: "finance",
  //   icon: Wallet,
  //   section: "main",
  //   path: ["/app/finance"],
  //   items: [
  //     {
  //       title: "Finance",
  //       href: "/app/finance",
  //       path: ["/app/finance"],
  //       items: [],
  //     },
  //   ],
  // },
  {
    title: "User Management",
    href: "/app/user",
    code: "usermanagement",
    modules: ["user", "role"],
    icon: Users,
    section: "settings",
    path: ["/app/user", "/app/role", "/app/role/add", "/app/role/edit"],
    items: [
      {
        title: "User",
        section: "User Management",
        href: "/app/user",
        modules: ["user"],
        path: ["/app/user"],
        items: [],
      },
      {
        title: "Role",
        section: "User Management",
        href: "/app/role",
        modules: ["role"],
        path: ["/app/role", "/app/role/add", "/app/role/edit"],
        items: [],
      },
    ],
  },
  {
    title: "Setting",
    href: "/app/app-setting",
    code: "setting",
    modules: ["app_config", "bq_master_item"],
    icon: MonitorCog,
    section: "settings",
    path: [
      "/app/app-setting",
      "/app/bq-master-item",
      "/app/bq-master-item/create-bq-master-item",
      "/app/bq-master-item/update-bq-master-item",
    ],
    items: [
      {
        title: "App Setting",
        href: "/app/app-setting",
        modules: ["app_config"],
        path: ["/app/app-setting"],
        items: [],
      },
      {
        title: "BQ Master Item",
        section: "Finance",
        href: "/app/bq-master-item",
        modules: ["bq_master_item"],
        path: [
          "/app/bq-master-item",
          "/app/bq-master-item/create-bq-master-item",
          "/app/bq-master-item/update-bq-master-item",
        ],
        items: [],
      },
    ],
  },
]
